import makeStyles from '@mui/styles/makeStyles'

const useInternalUserlistStyles = makeStyles({
  root: {},
})

export default useInternalUserlistStyles
